import React from "react";
import { useIntl } from "react-intl";
import { PeekPaper, PeekStack, PeekTypography, useTheme } from "@piiqtechnologies/ui-components";
import messages from "./messages.i18n";
export const AiDiscoverabilityResultContent = ({ results }) => {
    const intl = useIntl();
    const theme = useTheme();
    return (React.createElement(PeekPaper, { variant: "outlined", sx: {
            py: theme.spacing(2),
            px: theme.spacing(2.5),
            textAlign: "left",
            border: `1px dashed ${theme.palette.grey[200]}`,
        } }, (results === null || results === void 0 ? void 0 : results.result.results.map((result) => {
        return (React.createElement(PeekStack, null,
            React.createElement(PeekTypography, { fontWeight: theme.typography.fontWeightMedium }, result.originLLM),
            React.createElement(PeekTypography, null, result.result)));
    })) || React.createElement(PeekTypography, null, intl.formatMessage(messages.aiDiscoverabilityResultsPlaceholder))));
};
export default AiDiscoverabilityResultContent;
